// https://vuex.vuejs.org/en/getters.html

export default {
  addresses(state) {
    return state.addresses;
  },
  errors(state) {
    return state.errors;
  },
  loading(state) {
    return state.loading;
  },
  totalCount(state) {
    return state.totalCount;
  }
};
